<template>
  <div class="reset-pwd">
    <div class="reset-left"></div>
    <a-form class="form" :form="form">
      <div class="logo">
        <img src="../../assets/images/account/logo.png" alt="">
      </div>
      <a-form-item class="marginBottom">
        <a-input :maxLength="11"
          v-decorator="['phone',{ rules: [{validator:check }] ,
            validateTrigger: ['change', 'blur'] },]"
          placeholder="手机号码"
        ><a-icon slot="prefix" type="user" style="color:rgba(0,0,0,.25)" /></a-input>
      </a-form-item>

      <a-form-item class="marginBottom">
        <div class="code">
          <a-input
            v-decorator="['code',{ rules: [{ required: true, message: '请输入验证码!' }] },]"
            placeholder="验证码"
          >
            <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
          </a-input>
          <img @click="getCodeImg" style="width: 130px;height:36px;cursor:pointer;" :src="codeUrl">
        </div>
      </a-form-item>

      <!-- 验证码 -->
      <a-form-item class="marginBottom">
        <div class="code">
          <a-input
          v-decorator="['verificationCode',{ rules: [{ required: true, message: '请输入验证码!' }] },]"
          placeholder="请输入验证码"
        >
          <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" />
        </a-input>
        <a-button type="primary" :disabled="countDownLoading" @click="getCode">{{countDownText}}</a-button>
        </div>
      </a-form-item>

      <!-- 新密码 -->
      <a-form-item class="marginBottom">
        <a-input
          @click="handlePasswordInputClick"
          v-decorator="['password1',{rules: [{ required: true, message: '至少6位密码，区分大小写'}, { validator: this.handlePasswordLevel }], validateTrigger: ['change', 'blur']}]"
          placeholder="6到18位数字加字母组合密码"
          type="password"
        ><a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" /></a-input>
      </a-form-item>

      <!-- 确认密码 -->
      <a-form-item class="marginBottom">
        <a-input
          v-decorator="['password2',{ rules: [{ required: true, message: '密码不能为空' }] },]"
          placeholder="确认密码"
          type="password"
        ><a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)" /></a-input>
      </a-form-item>

      <!-- 重置密码按钮 -->
      <a-form-item style="width: 80%;margin: 50px auto 0 auto;">
        <a-button type="primary" :loading="loading" block @click="handleSubmit">{{buttonText}}</a-button>
        <a-button style="margin-top:10px;" :loading="loading" block @click="goback()">返回</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { getCodeImg , sendSmsCode, forgetPass} from '@/api/account'
import {checkPhone} from '@/utils'

export default {
  props: [ 'device' ],
  data() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      buttonText: '重置密码',
      timer: null,
      countDownText: '获取验证码', // 获取验证码按钮文本
      countDownLoading: false,
      codeUrl:'',
      uuid: '',
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
      },
    };
  },

  created() {
    this.getCodeImg();
    // this.countDown()
  },

  methods: {
    goback(){
      this.$router.push('/account/login')
    },
    check (rule, value, callback) {
      checkPhone(rule, value, callback)
    },
    handlePasswordInputClick () {
      this.state.passwordLevelChecked = true
      return
    },
    // 密码强度验证
    handlePasswordLevel (rule, value, callback) {
      let level = 0
      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.state.passwordLevel = level
      this.state.percent = level * 30
      if (level >= 2) {
        if (level >= 3) {
          this.state.percent = 100
        }
        callback()
      } else {
        if (level <= 0) {
          this.state.percent = 10
        }
        callback(new Error('密码强度不够'))
      }
    },
    // 获取图片验证码
    async getCodeImg() {
      try {
        const data = await getCodeImg()
        this.codeUrl = `data:image/gif;base64,${data.img}`
        this.uuid = data.uuid
      } catch (error) {
        console.log(error)
      }
    },
    // 倒计时
    countDown() {
      // debugger;
      let that = this
      try {
        let sendCode = that.$pub.getCookie('reset_pwd_time')
        if(sendCode) {
          that.countDownLoading = true
          let count = parseInt(sendCode)
          var timer = setInterval(() => {
            // that.$cookies.set('reset_pwd_time', count, { expires: 0.5 })
            count--
            that.countDownText = `剩余${count}秒`
            if(count <= 0) {
              that.countDownText = '获取验证码'
              that.countDownLoading = false
              // that.$cookies.remove('reset_pwd_time')
              clearInterval(timer)
              that.timer = null
            }
          }, 1000);
        }
      } catch (error) {
        console.log(error)
      }
    },

    // 获取验证码
    async getCode() {
      let that = this
      try {
        that.$cookies.set('reset_pwd_time', 60, {expires: 0.5})
        let params = {
          scope:'reset',
          phoneNumber: this.form.getFieldValue('phone'),
          code: this.form.getFieldValue('code'),
          uuid: this.uuid
        }
        this.form.validateFields(['phone','code'])
        // console.log(params)
        // return false
        let data = await sendSmsCode(params)
        // console.log(data)
        that.countDown()
      } catch (error) {
        console.log(error)
      }
      // try {
      //   that.$cookies.set('reset_pwd_time', 60, { expires: 0.5 })
      //   that.countDown()
      // } catch (error) {
      //   console.log(error)
      // }
    },

    // 设置按钮加载状态跟文字
    setBtnStatus(status, text) {
      this.loading = status
      this.buttonText = text
    },

    // 提交按钮点击回调
    handleSubmit() {
      let that = this
      try {
        that.form.validateFields( async(err, params) => {
          if(params.password1 != params.password2){
            this.$message.error('两次密码不同')
          } else {
            that.setBtnStatus(true, '正在重置')
            if(!err) {
              var passwordparams = {
                phone: params.phone,
                phoneCode: params.verificationCode,
                password: params.password1,
              }
              // let pwd1 = that.$pub.setMD5(params.password1)
              // let pwd2 = that.$pub.setMD5(params.password2)
              let data = await forgetPass(passwordparams)
              that.$message.success('重置成功')
              // return false
              setTimeout(() => {
                that.setBtnStatus(false, '重置密码')
                that.$router.push('/account/login')
              }, 1000);
            } else {
              that.setBtnStatus(false, '重置密码')
            }
          }
        })
      } catch (error) {
        console.log(error)
      }
    }
  }
};
</script>

<style lang="less" scoped>
.marginBottom{
  margin-top: 15px !important;
  width: 80%;
  margin: 0 auto;
  border-bottom: 1px solid #c2c2c2;
  .ant-btn {height: 40px;}
}
.reset-pwd {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .reset-left {
    width: 60%;
    height: 100%;
    background: url('../../assets/images/login-bg.png') center no-repeat;
    background-size: 100% 100%;
  }
  &.mobile {
    .description, .title, .form { width: 95%;}
  }
  .form {
    width: 40%;
     width: 40%;
      height: 100%;
      padding: 150px 100px;
      .logo {
        width: 157px;
        height: 111px;
        margin: 20px auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
    .ant-btn {height: 53px;}
    /deep/.ant-input {
      height: 60px;
      line-height: 60px;
      border: none ;
      outline: none;
      box-shadow: none;
    }
    .code {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .ant-btn {height: 40px;}
      /deep/.ant-input {width: calc(100% - 5px);}
    }
  }
}
@media only screen and (max-width: 414px){
  .reset-pwd {
    .reset-left {
      display: none;
    }
    .form {
      width: 100%;
      padding: 0;
        .ant-btn {height: 30px;}
        /deep/.ant-input {
          height: 30px;
          line-height: 30px;
          border: none ;
          outline: none;
          box-shadow: none;
        }
    }
  }
}
</style>
